export default __webpack_public_path__ + "static/media/sponsor1.80083b18.png";